import { endpoints } from './endpoints'
import request from '../request'

function post(url, data) {
  return request({ url, method: 'post', data }).then(response => response)
}

export function getFileActivitySummary(data) {
  return post(endpoints.getFileActivitySummary, data)
}

export function getFileActivity(data) {
  return post(endpoints.getFileActivity, data)
}

export function getFileActivityPDF(data) {
	return post(endpoints.getFileActivityPDF, data)
}

export function recordFileActivity(data) {
  return post(endpoints.recordFileActivity, data)
}

export function getProjectStorageSize(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectStorageSize,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteFile(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteFile,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getFileAssociations(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getFileAssociations,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

